module.exports = __webpack_public_path__ + "img/lightning-bolt-red.45218d51.png";